module.exports = __webpack_public_path__ + "dashboard/img/eye.df1fe1e9dec644eed24e98e787e145d4.svg";